import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute(
  "/app/admin-settings/users/new/users-for-persons"
)({
  beforeLoad: (context) => {
    return {
      getTitle: () =>
        context.context.t && context.context.t("CreateUsersForPersons"),
    }
  },
  component: lazyImportRouteComponent(
    () => import("./-components/UsersForPersonsPage"),
    "UsersForPersonsPage"
  ),
})
